export const GENERIC_EXCEPTION = 'Something went wrong. Please try again later.';
